/**
 * swipe.ts — минимальный touch-свайп для изображений
 * Проект: TorgiRT (shared — все витрины)
 *
 * Подключается на .modal-main-image и .image-viewer-content
 * для навигации по изображениям свайпом влево/вправо.
 * Листовой модуль без импортов.
 */

const SWIPE_THRESHOLD = 50;
const RATIO = 1.5;

/**
 * Подключает touch-свайп на элемент.
 */
export function initSwipe(
  element: HTMLElement | null,
  onSwipeLeft: () => void,
  onSwipeRight: () => void
): void {
  if (!element) return;

  let startX = 0;
  let startY = 0;

  element.addEventListener("touchstart", function (e: TouchEvent) {
    const touch = e.changedTouches[0];
    if (touch) {
      startX = touch.clientX;
      startY = touch.clientY;
    }
  }, { passive: true });

  element.addEventListener("touchend", function (e: TouchEvent) {
    const touch = e.changedTouches[0];
    if (!touch) return;
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);

    if (absDx > SWIPE_THRESHOLD && absDx > absDy * RATIO) {
      if (dx < 0) {
        onSwipeLeft();
      } else {
        onSwipeRight();
      }
    }
  }, { passive: true });
}
